import React from 'react';
import './Spinner.css';

const Spinner = ({ size = 'medium', color = 'primary', className = '' }) => {
  const sizeClass = `spinner-${size}`;
  const colorClass = `spinner-${color}`;
  
  return (
    <div className={`spinner-container ${className}`}>
      <div className={`spinner ${sizeClass} ${colorClass}`}></div>
    </div>
  );
};

export default Spinner; 